import React from 'react';
import ReactDOM from 'react-dom/client';
import './index.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import { StateProvider } from './Reducer/reducer';
import reducer,{initialState} from './Reducer/StateProvider';
import reportWebVitals from './reportWebVitals';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(
  
  <StateProvider initialState={initialState} reducer={reducer}>
  {/* <React.StrictMode> */}
    <BrowserRouter>
    <App />
    </BrowserRouter>
  {/* </React.StrictMode> */}
  </StateProvider>
);

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
